import { render, staticRenderFns } from "./index.vue?vue&type=template&id=520a4b86&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=520a4b86&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=520a4b86&prod&scoped=true&lang=css"
import style2 from "./index.vue?vue&type=style&index=2&id=520a4b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a4b86",
  null
  
)

export default component.exports